import { AppNotificationType } from '@deltager/organizers/admin/shared/models/AppNotificationType';
import { Action } from '@ngrx/store';

export enum EventSetupUIActionTypes {
  ShowNotification = '[Event setup UI] Show notification',
}

export class ShowNotificationAction implements Action {
  readonly type = EventSetupUIActionTypes.ShowNotification;

  constructor(public payload: { notificationType: AppNotificationType; message: string }) {}
}
